 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"nginx": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"nginx": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-2d0abc0b":"715bbc28","chunk-2d0af4d6":"dc96d342","chunk-2d0af678":"99dd37fd","chunk-2d0b2b74":"9a03af69","chunk-2d0b5fc7":"9c7f1eae","chunk-2d0b9204":"b14b4cf1","chunk-2d0bdd2d":"62c2a365","chunk-2d0c230a":"87fccce6","chunk-2d0cef92":"1fc92dba","chunk-2d0db7da":"28b6eb2a","chunk-2d0e8be0":"982dc284","chunk-2d2295ab":"a0974950","chunk-3c14fec2":"9c091cfe","chunk-3c1904b8":"7e5ab428","chunk-53f21a9e":"f1fac9f8","chunk-69cbc1d2":"a349daea","chunk-6fea53c8":"8e066e26","chunk-c66b0ce2":"4806c6fc","chunk-2d0c17b7":"685d4d91","chunk-3c133de8":"8ac41d99","chunk-2d0cc691":"6c06fb21","chunk-2d0b59f4":"0e789c27","chunk-2d0b9831":"73aa2419","chunk-2d0ab0b6":"debd6a75","chunk-2d0c822a":"30bb522c","chunk-2d0e6374":"cdb03d9b","chunk-2d22d789":"77e937fe","chunk-40480906":"225ec08d","chunk-ac4da4da":"f9d225a6","chunk-2d0dd02d":"4b474c23","chunk-2d0c4dcc":"328556f6","chunk-2d2217d7":"29829d52","chunk-2d2375dd":"93a0e05c","chunk-051ae414":"ebccbd45","chunk-2d0b26e8":"5a5c8450","chunk-2d0d7e34":"b8b03101","chunk-2d208325":"e7710cc7","chunk-2d0cfe35":"776cf015","chunk-2d0cbde5":"caac778b","chunk-2d2218af":"84533e81","chunk-2d0b6afa":"616dc06e","chunk-2d0baabb":"c66c3ca4","chunk-2d0d7e38":"8016ab23","chunk-2d225d99":"21003556","chunk-2d229396":"591260ee","chunk-2d0b361c":"93eb8be9","chunk-2d0db2a6":"8f6ac8cc","chunk-c0cec4da":"7cf60809","chunk-2d0d6b72":"cfe6c73e","chunk-2d22179c":"feda8835","chunk-202e9329":"4976feb3","chunk-2d0d3104":"da3e8f28","chunk-2d0e4490":"590b6fee","chunk-2d0e4891":"41f5df33","chunk-2d0e666a":"15f77d1a","chunk-2d20791d":"4be736b7","chunk-2d229085":"b2386e51","chunk-9c38a356":"30915bc8","chunk-cd9fc2c2":"acce98f6","chunk-2d0dd660":"b3e1588d","chunk-2d0a3c4a":"46525acd","chunk-0befe426":"454df05c","chunk-2a0e44fe":"c921e76d","chunk-2d0e1d30":"b2ebb665","chunk-2d0e91c5":"b1df4bd4","chunk-2d216ecb":"9abbc296","chunk-2d217a2e":"598ce49a","chunk-2d2228ce":"921f0c7a","chunk-2d0d7e45":"2c83b605","chunk-2d21dca0":"763ff824","chunk-2d0ac90d":"b9f3ba47"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-53f21a9e":1,"chunk-69cbc1d2":1,"chunk-6fea53c8":1,"chunk-c66b0ce2":1,"chunk-40480906":1,"chunk-051ae414":1,"chunk-202e9329":1,"chunk-9c38a356":1,"chunk-cd9fc2c2":1,"chunk-0befe426":1,"chunk-2a0e44fe":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-2d0abc0b":"31d6cfe0","chunk-2d0af4d6":"31d6cfe0","chunk-2d0af678":"31d6cfe0","chunk-2d0b2b74":"31d6cfe0","chunk-2d0b5fc7":"31d6cfe0","chunk-2d0b9204":"31d6cfe0","chunk-2d0bdd2d":"31d6cfe0","chunk-2d0c230a":"31d6cfe0","chunk-2d0cef92":"31d6cfe0","chunk-2d0db7da":"31d6cfe0","chunk-2d0e8be0":"31d6cfe0","chunk-2d2295ab":"31d6cfe0","chunk-3c14fec2":"31d6cfe0","chunk-3c1904b8":"31d6cfe0","chunk-53f21a9e":"8cdc401f","chunk-69cbc1d2":"e1567d9b","chunk-6fea53c8":"5915b54c","chunk-c66b0ce2":"80031f29","chunk-2d0c17b7":"31d6cfe0","chunk-3c133de8":"31d6cfe0","chunk-2d0cc691":"31d6cfe0","chunk-2d0b59f4":"31d6cfe0","chunk-2d0b9831":"31d6cfe0","chunk-2d0ab0b6":"31d6cfe0","chunk-2d0c822a":"31d6cfe0","chunk-2d0e6374":"31d6cfe0","chunk-2d22d789":"31d6cfe0","chunk-40480906":"83d65b30","chunk-ac4da4da":"31d6cfe0","chunk-2d0dd02d":"31d6cfe0","chunk-2d0c4dcc":"31d6cfe0","chunk-2d2217d7":"31d6cfe0","chunk-2d2375dd":"31d6cfe0","chunk-051ae414":"6c6fe4a3","chunk-2d0b26e8":"31d6cfe0","chunk-2d0d7e34":"31d6cfe0","chunk-2d208325":"31d6cfe0","chunk-2d0cfe35":"31d6cfe0","chunk-2d0cbde5":"31d6cfe0","chunk-2d2218af":"31d6cfe0","chunk-2d0b6afa":"31d6cfe0","chunk-2d0baabb":"31d6cfe0","chunk-2d0d7e38":"31d6cfe0","chunk-2d225d99":"31d6cfe0","chunk-2d229396":"31d6cfe0","chunk-2d0b361c":"31d6cfe0","chunk-2d0db2a6":"31d6cfe0","chunk-c0cec4da":"31d6cfe0","chunk-2d0d6b72":"31d6cfe0","chunk-2d22179c":"31d6cfe0","chunk-202e9329":"8178e2e0","chunk-2d0d3104":"31d6cfe0","chunk-2d0e4490":"31d6cfe0","chunk-2d0e4891":"31d6cfe0","chunk-2d0e666a":"31d6cfe0","chunk-2d20791d":"31d6cfe0","chunk-2d229085":"31d6cfe0","chunk-9c38a356":"a4de8dbd","chunk-cd9fc2c2":"639a70eb","chunk-2d0dd660":"31d6cfe0","chunk-2d0a3c4a":"31d6cfe0","chunk-0befe426":"4fcf0f79","chunk-2a0e44fe":"43ee31f6","chunk-2d0e1d30":"31d6cfe0","chunk-2d0e91c5":"31d6cfe0","chunk-2d216ecb":"31d6cfe0","chunk-2d217a2e":"31d6cfe0","chunk-2d2228ce":"31d6cfe0","chunk-2d0d7e45":"31d6cfe0","chunk-2d21dca0":"31d6cfe0","chunk-2d0ac90d":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quotes/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([10,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
